import styled from '../../styles/styled';
import { layout, space } from 'styled-system';
export const Button = styled.button(({ theme, size = 'medium', disabled }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: `${theme.iconButtonSizes[size]}`,
    width: `${theme.iconButtonSizes[size]}`,
    border: 'none',
    cursor: disabled ? 'not-allowed' : 'pointer',
}), ({ highlight, shadow, shape = 'circle', theme, background = 'white' }) => ({
    boxShadow: shadow ? theme.shadow.small : undefined,
    background: theme.colors[background],
    borderRadius: shape === 'square' ? undefined : '50%',
    ':hover': {
        boxShadow: shadow ? theme.shadow.large : undefined,
        backgroundColor: highlight ? theme.colors[highlight] : undefined,
    },
}), layout, space);
Button.defaultProps = {
    type: 'button',
};
//# sourceMappingURL=icon_button.styles.js.map